<template>
  <vue-custom-scrollbar class="scroll_wrap">
    <v-row
      class="ma-0 px-6 px-md-15 py-5 bg-gray"
      align="center"
      justify="space-between"
    >
      <v-col cols="auto" class="pa-0">
        <v-row class="ma-0" align="center">
          <v-col cols="auto" class="pa-0 mr-5">
            <v-img src="~@/img/main_img_assignment.png"></v-img>
          </v-col>
          <v-col cols="auto" class="pa-0">
            <span class="tab-title mr-4"> 확인서</span>
            <span class="count">{{ confirmList.length }}</span>
            <span class="unit">&nbsp; 건</span>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row class="mx-0 mx-md-15 mt-4 mt-md-8 mb-0">
      <v-col class="pa-0">
        <template
          v-for="(confirmGroup, stepType) in groupBy(confirmList, 'stepType')"
        >
          <v-row
            :key="stepType"
            class="ma-0 px-6 py-4 bg-gray bd-B-2px"
            align="center"
            justify="space-between"
          >
            <v-col cols="auto" class="pa-0 head-title">
              {{
                stepType == 'PAPER_INTERVIEW'
                  ? '온라인전형 확인서'
                  : '면접 확인서'
              }}
            </v-col>
          </v-row>

          <v-row
            v-for="(confirm, idx) in confirmGroup"
            class="ma-0 px-6 py-5 bd-B-1px d-md-flex"
            align="center"
            justify="space-between"
            :key="stepType + idx"
          >
            <v-col cols="auto" class="pa-0 list-title">{{
              confirm.annoTitle + ' (' + confirm.stepNm + ')'
            }}</v-col>
            <v-col cols="auto" class="pa-0 ml-10 data-created"
              >확인기간<span class="ml-3"
                >{{ confirm.startDate | momentDate('YYYY-MM-DD') }} ~
                {{ confirm.endDate | momentDate('YYYY-MM-DD') }}</span
              ></v-col
            >
            <v-col cols="auto" class="pa-0">
              <v-btn class="ml-6 btn-type-06" @click="showReport(confirm)">
                보기</v-btn
              >
            </v-col>
          </v-row>
        </template>
      </v-col>
    </v-row>
  </vue-custom-scrollbar>
</template>

<script>
import { API } from '@/api/network';
import { groupBy } from '@/utils/util';
import { reportFile } from '@/utils/reportFile.js';
// import { reportFile } from '@/utils/reportFile.js';
export default {
  mounted() {
    this.fetchAgree();
  },
  data() {
    return {
      confirmList: [],
    };
  },

  methods: {
    groupBy,
    async fetchAgree() {
      this.$showLoading();
      this.confirmList = [];
      await API.getAuthJson('/confirmList', {}).then(res => {
        this.$hideLoading();
        this.confirmList = res.data;
      });
      this.$hideLoading();
    },

    showReport(li) {
      var options = { enableCloseButton: false, timeout: 10000 };

      reportFile(li.mrdPath, li.mrdParam, options, null);
    },
  },
};
</script>

<style></style>
